<template>
    <div class="details Mydetails" style="height: 100%;">
        <navbar :transparent="isTransparent"></navbar>
        <h1 class="profile-title details-width">{{$t('user_center_reset_password')}}</h1>
        <div>
            <div class="Reset_box">
                <div class="Reset_list">
                    <p class='Reset_text'>{{$t('user_center_new_password')}}</p>
                    <Input class="Reset_input" v-model="res_psw" :placeholder="this.$t('user_center_new_password')" name="New Password"></Input>
                    <br>
                    <Input class="Reset_input" v-model="con_psw" :placeholder="this.$t('user_center_account_password_re_psw')"
                           name="Confirm password"></Input>
                    <div style="margin-top: 2%;">
                        <Checkbox v-model="single"></Checkbox>
                        <p 　class="Reset_agree">{{$t('agree_rule')}}
                            <router-link class="text-primary" :to="{name: 'terms_of_service'}">
                                {{$t('agree_terms_of_conditions')}}
                            </router-link>
                            ,
                            <router-link :to="{name: 'privacy_policy'}"  class="text-primary">{{$t('agree_privacy_policy')}}
                            </router-link>
                            {{$t('and')}}
                            <router-link :to="{name: 'terms_of_law'}" class="text-primary">{{$t('agree_terms_of_law')}}
                            </router-link>
                            .</p>
                    </div>
                    <Button type="primary" @click="reset">OK</Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    import message from '../Profiler/Common/Message.vue'
    import config from '../../lib/config'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                isTransparent: false,
                res_psw: '',
                con_psw: '',
                single: false
            }
        },
        components: {
            navbar,
            message
        },
        methods: {
            reset () {
                if (this.single === false) {
                    this.$Message.error(this.$t('user_message_please_argee'))
                    return false
                }
                if (this.res_psw === '' && this.con_psw === '') {
                    this.$Message.error(this.$t('user_message_password_cannt_null'))
                    return false
                }

                let module = 'index.php/index/user/email_repassword'

                let data = {}
                data.token = this.$route.query.token
                data.password = this.res_psw
                data.re_password = this.con_psw
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    // console.log('users', resp.data)
                    if (parseInt(resp.data.code) === 2001) {
                        this.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        this.$Message.success(this.$t('user_message_reset_password'))
                        // console.log('users', resp.data)
                        this.$router.push({
                            path: '/'
                        })
                    } else {
                        alert(resp.data.msg)
                    }
                }.bind(this))
            }
        }
    }
</script>

<style lang="scss">
    $body-width: 80%;
    .details-width {
        max-width: $body-width;
        margin: 0 auto;
    }

    .text-primary {
        color: #0084FF;
    }

    .Mydetails {
        text-align: left;
        margin-top: 60px;
        background-color: #EFF2F7;
        padding-bottom: 10%;
        @at-root .profile-title {
            font-weight: 500;
            font-size: 50px;
            color: #1F2D3D;
            text-align: left;
            padding: 2% 0;
        }
        .steps {
            width: 750px;
            margin: 0 auto;
        }
        .order-payment {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            margin-bottom: 100px;
            line-height: 24px;
            .pay-left {
                line-height: 2;
                h3 {
                    font-size: 24px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 26px;
                }
            }
            .pay-right {
                color: #5E6D82;
                line-height: 2;
                text-align: right;
                .real-pay {
                    font-size: 24px;
                }
            }
        }
        .ivu-poptip-inner {
            white-space: normal;
            padding: 10%;
            margin-top: 10px;
            display: none;
        }
        .ivu-steps-status-finish {
            &:hover {
                .ivu-poptip-inner {
                    display: block;
                }
            }

        }
    }

    .Reset_box {
        width: 80%;
        margin: 0 auto;
        background-color: #fff;
    }

    .Reset_list {
        width: 30%;
        margin: 0 auto;
        text-align: center;
        padding: 5% 0;
        min-width: 300px;
    }

    .Reset_text {
        text-align: left;
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 24px;
    }

    .Reset_list button {
        width: 45%;
        /*font-family: PingFangSC-Semibold;*/
        font-size: 22px;
        background: #0084ff;
        color: #FFFFFF;
        letter-spacing: 0;
        margin: 5% 0;
        padding: 0;
    }

    .ivu-checkbox-inner {
        border: 1px solid #5E6D82;
        border-radius: 5px;
    }

    .ivu-input {
        margin-top: 10px;
        font-size: 16px;
        padding: 20px 15px;
        border: 1px solid #99A9BF;
        border-radius: 5px;
    }

    .Reset_agree {
        /*font-family: Roboto-Light;*/
        font-size: 14px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 20px;
        display: inline;
    }

    .Reset_agree a {
        color: #0084ff;
    }

    @media only screen and (max-width: 414px) {
        .profile-title {
            font-size: 32px;
        }
        .Reset_box {
            width: 95%;
        }
    }

    @media only screen and (max-width: 320px) {
        .Reset_list {
            min-width: 280px;
        }
    }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?655bb29a